import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHero, Section } from "@/components/PageParts";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/context/SettingsContext";
import { Building2, Network, HeartHandshake, FileText, Bot, LineChart } from "lucide-react";

const ITEMS = [
  [Building2, "Create your company", "Learn to stand up an independent placement company in your chosen market and niche."],
  [Network, "Develop your provider network", "Recruit and manage your own participating providers and their capacity."],
  [HeartHandshake, "Build referral sources", "Develop professional referral relationships that drive private-pay demand."],
  [FileText, "Lawful provider agreements", "Understand approved written compensation arrangements (independent legal review required)."],
  [Bot, "AI workflows & automation", "Use AI to automate outreach, follow-up, and content."],
  [LineChart, "Operate independently", "Run KPIs, SOPs, and a repeatable business system."],
];

export default function BuildBusiness() {
  const nav = useNavigate();
  const settings = useSettings();
  return (
    <div>
      <PageHero eyebrow="Path 2 — Business Owner" title="Build your own placement business"
        subtitle="Go beyond individual placements. Learn to create and operate an independent local or specialized private-pay healthcare placement company." />
      <Section className="py-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map(([Icon, t, d]) => (
            <Card key={t} className="p-6" data-testid={`build-${t}`}>
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-sky">
                <Icon className="h-5 w-5 text-clinical" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-navy">{t}</h3>
              <p className="mt-2 text-sm text-slate-500">{d}</p>
            </Card>
          ))}
        </div>
        <Card className="mt-12 grid gap-8 bg-navy p-10 text-white lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-clinical">The machine</p>
            <h2 className="mt-3 font-heading text-3xl font-semibold">Business-in-a-Box Accelerator</h2>
            <p className="mt-4 text-slate-300">
              The {settings.membership_price} membership teaches the business. The {settings.accelerator_price} Accelerator
              provides the machine — blueprint, 90-day plan, CRM, AI workflows, SOPs, and a business-launch wizard.
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:items-end">
            <Button data-testid="build-accelerator-btn" size="lg" onClick={() => nav("/business-in-a-box")} className="bg-clinical hover:bg-clinical/90">
              Explore Business-in-a-Box — {settings.accelerator_price}
            </Button>
            <Button data-testid="build-join-btn" size="lg" variant="outline" onClick={() => nav("/join")}
              className="border-white/30 bg-transparent text-white hover:bg-white/10">
              Start with membership — {settings.membership_price}
            </Button>
          </div>
        </Card>
      </Section>
    </div>
  );
}
